import { render, staticRenderFns } from "./HoribaSamplesDataTable.vue?vue&type=template&id=44a9bc38"
import script from "./HoribaSamplesDataTable.vue?vue&type=script&lang=js"
export * from "./HoribaSamplesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports